import React from 'react';
import { makeStyles } from '@material-ui/core';
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import PauseRoundedIcon from '@material-ui/icons/PauseRounded';
import Checkbox from '@material-ui/core/Checkbox';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import clsx from 'clsx';

//workstation tile in the workstation overview
export default function WorkstationTile(props) {
    const classes = useStyles();

    let stateIcon = <React.Fragment></React.Fragment>;
    let state = ""
    let borderLeft = ""
    if (props.orders.some(x => x.state === 'running')) {
        stateIcon = <PlayArrowRoundedIcon className={classes.play}></PlayArrowRoundedIcon>;
        state = "RUNNING"
        borderLeft = "solid 8px rgb(92,201,88,0.2)"
    }
    else if (props.orders.some(x => x.state === 'paused')) {
        stateIcon = <PauseRoundedIcon className={classes.pause} ></PauseRoundedIcon>;
        state = "PAUSED"
        borderLeft = "solid 8px rgb(245,145,39,0.2)"
    }
    else if (props.orders.some(x => x.state === 'stopped')) {
        stateIcon = <div className={classes.stop}></div>;
        state = "STOPPED"
        borderLeft = "solid 8px rgb(216,73,73,0.2)"
    }
    else if (props.orders.some(x => x.state === 'cancelled')) {
        stateIcon = <div className={classes.cancel}><svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 121.31 122.876" enableBackground="new 0 0 121.31 122.876"><g><path fillRule="evenodd" clipRule="evenodd" d="M90.914,5.296c6.927-7.034,18.188-7.065,25.154-0.068 c6.961,6.995,6.991,18.369,0.068,25.397L85.743,61.452l30.425,30.855c6.866,6.978,6.773,18.28-0.208,25.247 c-6.983,6.964-18.21,6.946-25.074-0.031L60.669,86.881L30.395,117.58c-6.927,7.034-18.188,7.065-25.154,0.068 c-6.961-6.995-6.992-18.369-0.068-25.397l30.393-30.827L5.142,30.568c-6.867-6.978-6.773-18.28,0.208-25.247 c6.983-6.963,18.21-6.946,25.074,0.031l30.217,30.643L90.914,5.296L90.914,5.296z" /></g></svg></div>;
        state = "CANCELLED"
        borderLeft = "solid 8px rgb(2,1,0,0.2)"
    }
    else if (props.orders.some(x => x.state === 'planned')) {
        stateIcon = <img className={classes.menuIcon} alt="menu" src={process.env.PUBLIC_URL + '/img/planned.svg'}></img>
        state = "PLANNED"
        borderLeft = "solid 8px rgb(2,1,0,0.2)"
    }

    return (
        <div className={classes.workstation} style={{ borderLeft: borderLeft }}>
            <div className={classes.line}>
                LINE
            </div>
            <div className={classes.lineId}>
                {props.workstation.id}
            </div>
            <div className={classes.stateContainer}>
                <div className={classes.stateIcon}>
                    {stateIcon}
                </div>
                <div className={classes.state}>
                    {state}
                </div>
            </div >
            <div className={classes.checkboxContainer}>
                <div className={classes.checkboxDiv}>
                    <Checkbox
                        className={classes.checkBox}
                        disableRipple
                        color="default"
                        checked={props.active}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                        onChange={() => props.activateWorkstation(props.workstation.id)}
                    /></div>

            </div>
        </div>
    )

}

const useStyles = makeStyles(() => ({
    play: {
        color: "#5CC958",
        height: "30px",
        width: "30px"
    },
    stop: {
        height: "15px",
        width: "15px",
        backgroundColor: "#D84949",
        borderRadius: "3px",
        margin: "10px",
        marginTop: "8px"
    },
    pause: {
        height: "30px",
        width: "30px",
        color: "#F59127",
        marginLeft: "5px"
    },
    cancel: {
        margin: "10px",
        marginTop: "8px",
        marginLeft: "12px"
    },
    line: {
        color: "#8D8D8D",
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingTop: "25px",
        paddingBottom: "5px"

    },
    lineId: {
        color: "#000000",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingBottom: "5px"

    },
    stateContainer: {
        paddingLeft: "20px",
        height: "20px"
    },
    stateIcon: {
        float: "left"
    },
    state: {
        float: "left",
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        paddingTop: "7px"
    },
    workstation: {
        height: "180px",
        backgroundColor: "white",
        borderRadius: "6px",
        width: "150px"
    },
    checkboxContainer: {
        width: "150px",
        textAlign: "center"
    },
    checkboxDiv: {
        width: "50px",
        marginLeft:"auto",
        marginRight:"auto"

    },
    checkBox: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
        marginTop: "3px"
    },
    icon: {
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
    },
}));